module.exports = __webpack_public_path__ + "img/wallet.0e96fb0c.png";